import React from 'react';
import { Link } from 'react-router-dom';
import snoozeScreenshot from '../assets/snooze-lock.png';

export default function Project2() {
  return (
    <div className="project1-text">
      <div className="mx-auto pt-5 px-6">

        <h1 className="text-4xl font-bold pb-3">
          SnoozeLock
        </h1>

        <p className="md:text-xl max-w-3xl mx-auto pb-3">
          Production iOS alarm application designed to help users get out of
          bed by requiring a task before an alarm can be dismissed.
        </p>

        <p className="project-tech">
          Swift • SwiftUI • AlarmKit • CoreMotion • StoreKit 2 • Camera / Barcode Scanning
        </p>

            <img
                  className="mx-auto mt-6 mb-8 true-lock-screenshot"
                  src={snoozeScreenshot}
                  alt="SnoozeLock iOS application"
                />


        <div className="p1button md:text-xl pb-10">
          <h3>
            <a
              href="https://apps.apple.com/app/snoozelock-alarm-clock/id6785264664"
              target="_blank"
              rel="noopener noreferrer"
            >
              View on the App Store
            </a>
          </h3>
        </div>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Product Overview
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          SnoozeLock is a native iOS alarm application built around
          challenge-driven alarm dismissal. Users can require tasks such as
          solving a math problem, completing a typing challenge, scanning a
          barcode, walking a specified number of steps, or recalling their
          reason for waking up before dismissing an alarm.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Engineering Challenges
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          Alarm functionality depends on reliable behavior across application
          state changes and real-world device conditions. The application must
          preserve alarm configuration, challenge state, and dismissal rules
          while coordinating with Apple's AlarmKit framework.
        </p>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          Several challenges also depend on native device capabilities. Step
          Count uses motion data, while Barcode Scan requires camera access and
          real-time barcode recognition. These workflows must integrate cleanly
          with the alarm state while remaining simple for the user.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          What I Built
        </h2>

        <div className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          <ul className="list-disc pl-8 space-y-3">
            <li>
              Native alarm creation and scheduling using Apple's AlarmKit
              framework.
            </li>

            <li>
              Math and typing challenges with configurable difficulty levels.
            </li>

            <li>
              Camera-based barcode scanning as an alarm dismissal challenge.
            </li>

            <li>
              Step-count challenges using native motion data.
            </li>

            <li>
              Mission Recall workflows that reinforce the user's reason for
              waking up.
            </li>

            <li>
              Challenge Stacking for completing multiple dismissal tasks in
              sequence.
            </li>

            <li>
              State-driven SwiftUI interfaces for alarm configuration,
              challenge selection, and premium functionality.
            </li>

            <li>
              One-time Pro monetization using StoreKit 2 with purchase
              restoration and premium feature gating.
            </li>
          </ul>
        </div>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Architecture & Technical Decisions
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          SnoozeLock uses state-driven SwiftUI architecture to coordinate alarm
          configuration, challenge selection, challenge execution, and premium
          feature access.
        </p>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          Challenge types are structured so that new dismissal methods can be
          added without tightly coupling them to the rest of the alarm
          workflow. This also supports Challenge Stacking, where multiple
          challenges can be completed sequentially before an alarm is
          dismissed.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Native Device Integration
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          SnoozeLock integrates with multiple Apple device capabilities,
          including AlarmKit for alarm behavior, CoreMotion for step-count
          challenges, and camera access for barcode scanning.
        </p>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          These features require permission handling, device testing, and
          careful coordination between application state and hardware-dependent
          workflows.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Testing & Release
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-4 text-left">
          SnoozeLock was tested extensively on physical iPhone hardware because
          alarm behavior, motion tracking, barcode scanning, and other
          device-dependent functionality cannot be fully validated in the
          simulator.
        </p>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          I managed the production release process including device testing,
          StoreKit validation, App Store Connect configuration, privacy
          disclosures, App Review submission, and production deployment.
        </p>


        <h2 className="text-2xl font-bold pt-5 pb-3">
          Product Development
        </h2>

        <p className="md:text-xl max-w-3xl mx-auto pb-8 text-left">
          SnoozeLock was designed around an extensible challenge system rather
          than a single alarm-dismissal method. This allows new challenges and
          premium functionality to be added while preserving a consistent alarm
          and challenge workflow.
        </p>


        <div className="p1button md:text-xl pb-10">
          <h3>
            <a
              href="https://apps.apple.com/app/snoozelock-alarm-clock/id6785264664"
              target="_blank"
              rel="noopener noreferrer"
            >
              View SnoozeLock on the App Store
            </a>
          </h3>

          <h3 className="pt-5">
            <Link to="/projects">
              Back to Projects
            </Link>
          </h3>
        </div>

      </div>
    </div>
  );
}